import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Avatar,
  useTheme,
} from "@mui/material";
import {
  CheckCircle,
  Group,
  Assignment,
  TrendingUp,
  ArrowForward,
} from "@mui/icons-material";
import { encodePackage } from "../../../../../utils/encryptionAuth";
import { decryptData } from "../../../../../utils/crypto";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const TaksContent = () => {
  const theme = useTheme();
  const [userData, setUserData] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    // Ambil data user dari localStorage
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      try {
        // Jika data di-encrypt, gunakan decrypt function
        const decryptedUser = decryptData(storedUser);
        setUserData(decryptedUser);
      } catch (error) {
        console.error("Failed to parse user data:", error);
      }
    }
  }, []);
  const handleLogin = () => {
    const data = {
      user_id: userData?.id,
      email: userData?.email,
      user: {
        user_full_name: userData?.userFullName,
        user_name: userData?.userFullName,
        user_phone_code: userData?.userPhoneCode,
        user_phone: userData?.userPhone,
        photo_profile: userData?.profileImageUrl,
      },
    };
    if (userData) {
      const encrypted = encodePackage(JSON.stringify(data));
      // window.open(
      //   `https://task.fingerspot.io/sign-in?data=${encrypted}`,
      //   "_blank"
      // );
      window.open(`https://task.joglo.ink/sign-in?data=${encrypted}`, "_blank");
    }
  };
  const features = [
    {
      icon: <Assignment fontSize="large" />,
      title: t("Dashboard_taskcontent.features.easyAssignment.title"),
      description: t(
        "Dashboard_taskcontent.features.easyAssignment.description"
      ),
    },
    {
      icon: <Group fontSize="large" />,
      title: t("Dashboard_taskcontent.features.teamCollaboration.title"),
      description: t(
        "Dashboard_taskcontent.features.teamCollaboration.description"
      ),
    },
    {
      icon: <CheckCircle fontSize="large" />,
      title: t("Dashboard_taskcontent.features.statusTracking.title"),
      description: t(
        "Dashboard_taskcontent.features.statusTracking.description"
      ),
    },
    {
      icon: <TrendingUp fontSize="large" />,
      title: t("Dashboard_taskcontent.features.productivityAnalysis.title"),
      description: t(
        "Dashboard_taskcontent.features.productivityAnalysis.description"
      ),
    },
  ];

  return (
    <Box
      sx={{
        mb: 4,
        backgroundColor: "white",
        borderRadius: 2,
        boxShadow: 1,
        p: { xs: 2, md: 4 },
        maxWidth: 1200,
        mx: "auto",
      }}
    >
      {/* Hero Section */}
      <Grid
        container
        spacing={6}
        alignItems="center"
        justifyContent="space-between"
        sx={{
          mb: { xs: 4, md: 8 },
          flexDirection: { xs: "column-reverse", md: "row" },
        }}
      >
        {/* Bagian Teks */}
        <Grid spacing={2} columns={{ xs: 4, md: 12 }}>
          <Box
            sx={{
              px: { xs: 0, md: 4 },
              textAlign: { xs: "center", md: "left" },
              mt: { xs: 3, md: 0 }, // Add top margin on mobile
            }}
          >
            <Box
              sx={{
                textAlign: { xs: "center", md: "left" },
                mb: 3,
                mx: { xs: "auto", md: 0 }, // Center horizontally on mobile
              }}
            >
              <Box
                component="img"
                src="/assets/icon/tc-tp-logo.png" // Ganti path sesuai lokasi logo kamu
                alt="Taks Connect Logo"
                sx={{
                  width: { xs: "140px", sm: "160px", md: "220px" },
                  height: "auto",
                  maxWidth: "100%",
                }}
              />
            </Box>

            <Typography
              variant="h5"
              component="h2"
              gutterBottom
              sx={{
                fontWeight: 600, // Increased weight for better readability
                color: theme.palette.text.primary,
                mb: 2,
                fontSize: { xs: "1.5rem", md: "1.75rem" }, // Responsive font size
              }}
            >
              {t("Dashboard_taskcontent.hero.title")}
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{
                color: theme.palette.text.secondary,
                fontSize: { xs: "0.95rem", md: "1.1rem" },
                mb: { xs: 3, md: 4 },
                lineHeight: 1.6, // Better readability
              }}
            >
              {t("Dashboard_taskcontent.hero.description")}
            </Typography>

            <Button
              variant="contained"
              onClick={handleLogin}
              size="medium"
              endIcon={<ArrowForward />}
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: 2,
                fontWeight: 600,
                fontSize: { xs: "0.9rem", md: "1rem" },
                textTransform: "none",
                boxShadow: theme.shadows[2],
                transition: "all 0.3s ease",
                minWidth: { xs: "100%", sm: "auto" }, // Full width on small mobile
                "&:hover": {
                  boxShadow: theme.shadows[4],
                  transform: "translateY(-2px)",
                },
              }}
            >
              {t("Dashboard_taskcontent.buttons.goToTaskConnect")}
            </Button>
          </Box>
        </Grid>
      </Grid>

      {/* Features Section */}

      <Box
        sx={{
          maxWidth: 1200,
          mx: "auto",
          px: { xs: 2, sm: 3, md: 4 },
          py: { xs: 4, md: 6 }, // Added vertical padding
        }}
      >
        <Typography
          variant="h4"
          component="h2"
          align="center"
          sx={{
            fontWeight: 700, // Increased weight for better visibility
            mb: { xs: 4, md: 6 }, // Responsive margin
            color: theme.palette.primary.main,
            fontSize: { xs: "1.75rem", md: "2rem" }, // Responsive font size
          }}
        >
          {t("Dashboard_taskcontent.sections.features")}
        </Typography>

        <Grid container spacing={{ xs: 3, md: 4 }} justifyContent="center">
          {features.map((feature, index) => (
            <Grid
              spacing={2}
              columns={{ xs: 12, md: 4, sm: 6 }}
              key={index}
              sx={{
                display: "flex",
                justifyContent: index % 2 === 0 ? "flex-end" : "flex-start",
                [theme.breakpoints.down("sm")]: {
                  justifyContent: "center",
                },
              }}
            >
              <Card
                sx={{
                  width: "100%",
                  maxWidth: 400,
                  height: "100%",
                  minHeight: { xs: 220, md: 250 },
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  p: { xs: 2, md: 3 },
                  border: "1px solid",
                  borderColor: theme.palette.grey[200],
                  borderRadius: 2,
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: 3,
                    borderColor: theme.palette.primary.light,
                    transform: "translateY(-5px)",
                  },
                }}
              >
                <Avatar
                  sx={{
                    backgroundColor: theme.palette.primary.light,
                    color: theme.palette.primary.contrastText,
                    width: 60,
                    height: 60,
                    mb: 3,
                  }}
                >
                  {feature.icon}
                </Avatar>

                <CardContent sx={{ p: 0 }}>
                  <Typography
                    variant="h6"
                    component="h3"
                    gutterBottom
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                    }}
                  >
                    {feature.title}
                  </Typography>

                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{
                      px: { xs: 0, sm: 1, md: 2 },
                    }}
                  >
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* CTA Section */}
      <Box
        sx={{
          mt: { xs: 6, md: 8 },
          p: { xs: 3, md: 4 },
          backgroundColor: theme.palette.primary.light,
          borderRadius: 2,
          textAlign: "center",
          color: "white",
          boxShadow: theme.shadows[4],
          mx: { xs: 2, md: "auto" }, // Add horizontal margin on mobile
          maxWidth: { md: 800, lg: 1000 }, // Constrain width on larger screens
        }}
      >
        <Typography
          variant="h4"
          component="h3"
          gutterBottom
          sx={{
            fontWeight: 700, // Increased weight
            mb: 2,
            fontSize: { xs: "1.5rem", md: "1.75rem" }, // Responsive font size
          }}
        >
          {t("Dashboard_taskcontent.cta.title")}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mb: { xs: 3, md: 4 },
            maxWidth: 600,
            mx: "auto",
            fontSize: { xs: "1rem", md: "1.1rem" }, // Slightly larger on desktop
            opacity: 0.9, // Slightly transparent for better hierarchy
          }}
        >
          {t("Dashboard_taskcontent.cta.description")}
        </Typography>
        <Button
          variant="contained"
          onClick={handleLogin}
          size="large"
          endIcon={<ArrowForward />}
          sx={{
            px: { xs: 3, md: 4 },
            py: 1.5,
            borderRadius: 2,
            fontWeight: 600,
            fontSize: "1rem",
            backgroundColor: "white",
            color: theme.palette.primary.main,
            minWidth: { xs: "100%", sm: "auto" }, // Full width on mobile
            "&:hover": {
              backgroundColor: "white",
              transform: "translateY(-2px)",
              boxShadow: theme.shadows[6],
            },
            transition: "all 0.3s ease",
          }}
        >
          {t("Dashboard_taskcontent.buttons.goToTaskConnect")}
        </Button>
      </Box>
    </Box>
  );
};

export default TaksContent;
